import React, { useCallback, useState } from 'react';
import EditTranscriptModal from './EditTranscriptModal';
import { useEditParagraph } from 'contexts/EditParagraphContext';
import { useTranscriptParagraph } from 'hooks/transcripts/queries';
import { useEditTranscriptMutation } from 'hooks/transcripts/mutations';
import { useAICoding } from 'hooks/ai_coding/queries';
import { getErrorType } from 'utils/versioningErrors';
import { AI_CODING_IN_PROGRESS } from 'constants/VersioningErrorConstants';
import OutOfDateTranscriptModal from './OutOfDateTranscriptModal';

const EditTranscriptContainer = ({ transcriptID }) => {
  const { editingParagraphId, isEditing, cancelEdit } = useEditParagraph();
  const { text, isLoading } = useTranscriptParagraph(transcriptID, editingParagraphId);
  const editMutation = useEditTranscriptMutation();
  const { isProcessing: isAICodingInProgress } = useAICoding(transcriptID);

  const handleSave = useCallback((newText) => {
    editMutation.mutate({
      transcriptId: transcriptID,
      paragraphId: editingParagraphId,
      newText: newText
    }, {
      onSuccess: () => {
        // Success - close modal
        cancelEdit();
      }
    });
  }, [editMutation, transcriptID, editingParagraphId, cancelEdit]);

  const handleHideModal = useCallback(() => {
    editMutation.reset(); // Clear any errors when closing
    cancelEdit();
  }, [cancelEdit, editMutation]);

  // Derive error code - AI coding in progress takes precedence
  const errorCode = isAICodingInProgress
    ? AI_CODING_IN_PROGRESS
    : getErrorType(editMutation.error);

  return (
    <>
      <EditTranscriptModal
        show={isEditing}
        text={isLoading ? "Loading..." : text}
        hideModal={handleHideModal}
        onSave={handleSave}
        saving={editMutation.isPending}
        errorCode={errorCode}
      />
      <OutOfDateTranscriptModal/>
    </>
  );
};

export default EditTranscriptContainer;